export const patriotic = [
  {
    number: 'PBB100',
    hasModel: false
  },
  {
    number: 'PBB101',
    hasModel: false
  },
  {
    number: 'PBB102',
    hasModel: false
  },
  {
    number: 'PBB103',
    hasModel: false
  },
  {
    number: 'PBB104',
    hasModel: false
  },
  {
    number: 'PBB105',
    hasModel: false
  },
  {
    number: 'PBB106',
    hasModel: false
  },
  {
    number: 'PBB107',
    hasModel: false
  },
  {
    number: 'PBB108',
    hasModel: false
  },
  {
    number: 'PBB109',
    hasModel: false
  },

]